import { IS_B2B } from '@/domains/core/settings/constants';

export const wishlistsSettings = {
  isPro: IS_B2B,
  theme: IS_B2B ? ('pro' as const) : ('default' as const),
};
